"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../mountIsland");
var Lang_js_1 = require("../Lang.js");
var apiResponse_1 = require("../apiResponse");
function GetARenewal() {
    var _a = (0, react_1.useState)(null), requestRenewal = _a[0], setRenewal = _a[1];
    var _b = (0, react_1.useState)(false), loadFailed = _b[0], setLoadFailed = _b[1];
    var id = window.location.pathname.split('/').pop();
    (0, react_1.useEffect)(function () {
        axios_1.default.get("/api/ministry/renewal?id=".concat(id))
            .then(function (response) {
            if (!(0, apiResponse_1.isJsonSuccess)(response) || !response.data.renewal) {
                console.error('Unexpected response loading renewal', response.status, response.data);
                setLoadFailed(true);
                return;
            }
            setRenewal(response.data.renewal);
        })
            .catch(function (error) {
            console.log(error);
            setLoadFailed(true);
        });
    }, [id]);
    if (loadFailed)
        return react_1.default.createElement("div", null, (0, Lang_js_1.__)('Your renewal could not be loaded. Please reload the page, and sign in again if you are prompted to.'));
    if (!requestRenewal)
        return react_1.default.createElement("div", null, "Loading...");
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(Box_1.default, { sx: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
            react_1.default.createElement(Typography_1.default, { variant: "h5", sx: { padding: '20px', backgroundColor: '#f5f5f5', color: '#333', borderRadius: '10px' } },
                "Renewal ID ",
                requestRenewal.id,
                " for ",
                requestRenewal.first,
                " ",
                requestRenewal.last,
                " on: ",
                requestRenewal.renewal_date),
            react_1.default.createElement(Button_1.default, { variant: "outlined", sx: { margin: '5px', padding: '5px', fontSize: '1.8rem' }, onClick: function () { window.history.back(); } }, "Back")),
        Object.entries(requestRenewal).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (react_1.default.createElement(Typography_1.default, { key: key, variant: "body1" },
                react_1.default.createElement("strong", null,
                    key,
                    ":"),
                " ",
                value === null ? 'N/A' : value));
        })));
}
exports.default = GetARenewal;
var renewalsContainer = document.getElementById('renewal-info');
if (renewalsContainer) {
    (0, mountIsland_1.mountIsland)(renewalsContainer, react_1.default.createElement(GetARenewal, null));
}
